import * as React from 'react';
import { SidebarContext } from '../../contexts/sidebar-context';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  const { isExpanded, setIsExpanded, pathname } = React.useContext(SidebarContext);
  const sidebarRef = React.useRef<any>(null);
  const [clickHandlerActive, setClickHandlerActive] = React.useState(false);

  function closeSidebar() {
    if (window.innerWidth < 1024) {
      setIsExpanded(!isExpanded);
    }
  }

  const handleClick = React.useCallback((event: any) => {
    if (
      sidebarRef.current &&
      !sidebarRef.current.contains(event.target) &&
      window.innerWidth < 1024
    ) {
      setIsExpanded(false);
    }
    event.stopPropagation();
  }, [setIsExpanded]);

  React.useEffect(() => {
    setClickHandlerActive(isExpanded);
  }, [isExpanded]);

  React.useEffect(() => {
    if (clickHandlerActive) {
      document.addEventListener('click', handleClick);
    } else {
      document.removeEventListener('click', handleClick);
    }
    return () => document.removeEventListener('click', handleClick);
  }, [clickHandlerActive, handleClick]);

  React.useEffect(() => {
    // Ensure the init function is called after the script loads
    let w = window as any;
    if (w && w['anj_39a70568_0b26_48ee_a12e_50a8315983f7']) {
      w['anj_39a70568_0b26_48ee_a12e_50a8315983f7'].init();
    }

  }, []);

  const pages = [
    {
      name: 'Degen Coin Flip',
      href: 'https://degencoinflip.com',
      notification: false,
      svgSrc: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 200 200"
          className="transition-all duration-300"
          fill={'#e3e3e3'}
        >
          <path d="M100,187.39c-48.18,0-87.39-39.2-87.39-87.39S51.82,12.61,100,12.61s87.39,39.2,87.39,87.39-39.2,87.39-87.39,87.39ZM100,19.48c-44.4,0-80.52,36.12-80.52,80.52s36.12,80.52,80.52,80.52,80.52-36.12,80.52-80.52S144.4,19.48,100,19.48Z" />
          <path d="M100,32.84c-37.09,0-67.16,30.07-67.16,67.16s30.07,67.16,67.16,67.16,67.16-30.07,67.16-67.16-30.07-67.16-67.16-67.16ZM70.68,105.18c-4.59,0-8.31-3.72-8.31-8.31s3.72-8.31,8.31-8.31,8.31,3.72,8.31,8.31-3.72,8.31-8.31,8.31ZM98.02,126.44c-7.88,0-14.28-7.15-14.28-15.98h28.55c0,8.83-6.39,15.98-14.27,15.98ZM129.32,105.18c-4.59,0-8.31-3.72-8.31-8.31s3.72-8.31,8.31-8.31,8.31,3.72,8.31,8.31-3.72,8.31-8.31,8.31Z" />
        </svg>
      ),
    },
    {
      name: 'Degen Crash',
      href: 'https://app.degencoinflip.com/crash',
      notification: false,
      svgSrc: (
        <svg
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 200"
          className="transition-all duration-300"
          fill={pathname === '/crash' || pathname === '/crash/' ? '#e3e3e3' : '#84898c'}
        >
          <path d="M22.49,137.04c.29.48.4,1.1.43,1.66.13,2.71-1.38,4.13-1.57,6.83s.59,5.78,3.08,7.14c2.63,1.43,5.97.35,8.63-1.01,4.84-2.47,9.19-5.83,14.34-7.66,9.95-3.55,20.93,2.21,21,12.74.03,4.15-1.54,8.19-3.6,11.86-2.86,5.1-6.81,9.77-12.01,12.81-12.01,7-29.19,6.51-39.31-2.56-13.41-12.01-4.23-31.03,4.97-41.12.86-.94,2.19-1.91,3.35-1.33.3.15.52.38.69.65Z" />
          <path d="M180.24,46.96c.17.38.33.76.47,1.13,3.68-32.64-1.87-36.44-2.27-36.66-.03-.03-.09-.09-.2-.17-.1-.09-.17-.14-.21-.16-.3-.34-5.2-4.95-36.3,5.64.4.06.8.13,1.21.22,6.48.87,14.57,4.59,22.13,10.67,7.56,6.08,12.93,13.19,15.16,19.33Z" />
          <path d="M172.84,45.68c-4.9-11.29-14.96-19.39-27.05-21.76-8.03-1.58-15.17.92-22.41,4.22-1.22.56-2.43,1.14-3.62,1.74-16.57,8.33-30.99,20.96-41.31,36.38-2.44,3.65-4.82,7.61-8.65,9.76-2.97,1.67-6.47,2.03-9.83,2.58-13.35,2.18-26.13,7.79-36.77,16.15-3.17,2.49-6.46,6.16-5.34,10.03,1.28,4.45,7.06,5.35,11.68,5.75,18.84,1.66,37.1,9.32,51.5,21.57,15.05,11.44,26.45,27.64,32.1,45.68,1.39,4.42,3.49,9.88,8.12,10.18,4.02.26,6.9-3.73,8.65-7.36,5.88-12.18,8.62-25.86,7.9-39.37-.18-3.4-.57-6.9.42-10.16,1.28-4.2,4.64-7.38,7.68-10.54,12.86-13.38,22.1-30.17,26.69-48.14.33-1.3.64-2.6.92-3.91,1.68-7.78,2.58-15.29-.68-22.8ZM135.04,75.72c-11.49-.36-20.53-9.7-20.18-20.85.35-11.16,9.95-19.91,21.44-19.55,11.5.36,20.53,9.7,20.18,20.85-.35,11.16-9.95,19.91-21.44,19.55Z" />
          <ellipse
            cx="136.59"
            cy="42.51"
            rx="3.72"
            ry="5.07"
            transform="translate(89.83 177.71) rotate(-88.21)"
          />
          <ellipse
            cx="133.9"
            cy="56.75"
            rx="7.54"
            ry="10.3"
            transform="translate(73 188.82) rotate(-88.21)"
          />
          <path d="M91.34,138.45c-.17-.51-.38-1.04-.78-1.4-.09-.08-.19-.16-.29-.22l-20.89-15.66c-3.85-2.82-11.29,1.47-13.9,4.28-.39.42-.76.88-.88,1.43-.14.66.09,1.34.34,1.96,3.28,8.31,9.66,15.26,17.47,19.58,4.46,2.47,9.38,4.07,14.46,4.59.62.06,1.27.1,1.83-.16.58-.28.96-.84,1.29-1.39,2.27-3.88,2.77-8.75,1.36-13.01Z" />
        </svg>
      ),
    },
    {
      name: 'Degen Towers',
      href: 'https://app.degencoinflip.com/towers',
      notification: false,
      svgSrc: (
        <svg
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 200"
          className="transition-all duration-300"
          fill={pathname === '/towers' || pathname === '/towers/' ? '#e3e3e3' : '#84898c'}
        >
          <path d="M54.12,52.41c2.44-1.26,5.27-1.31,7.76-.13,2.11,1.01,3.69,2.77,4.46,4.93l16.43-5.4c.02-5.35,4.21-9.77,9.55-10.07l7.77-.44,7.77.44c5.34.3,9.53,4.72,9.55,10.07l16.43,5.4c.77-2.16,2.35-3.92,4.47-4.93,2.48-1.18,5.31-1.14,7.76.13l.78.4v-28.68c0-1.06-.6-2.02-1.56-2.49l-8.06-3.93c-1.84-.9-3.98.44-3.98,2.49v5.41l-14.38-5.59v-3.04c0-3.96-3.21-7.16-7.16-7.16h-24.76c-3.96,0-7.16,3.21-7.16,7.16v3.42l-13.36,5.42v-5.62c0-2.05-2.14-3.38-3.98-2.49l-8.06,3.93c-.95.46-1.56,1.43-1.56,2.49v28.95l1.29-.67Z" />
          <path d="M51.7,102.57c1.95,1.15,3.33,3,3.78,5.25l.1.53,1.82-.56-.56-2.7c-.45-2.16.03-4.42,1.31-6.21,1.28-1.79,3.26-2.98,5.45-3.27l21.98-2.85c2.26-.31,4.55.4,6.27,1.91,1.72,1.51,2.7,3.68,2.7,5.97v2.35l5.2-.22c.22-.01.47-.01.71,0l5.17.22v-2.35c0-2.28.98-4.46,2.7-5.97,1.72-1.51,4-2.21,6.27-1.91l21.98,2.85c2.18.28,4.17,1.47,5.45,3.27,1.28,1.79,1.76,4.06,1.31,6.22l-.56,2.7,1.82.56.1-.53c.45-2.25,1.83-4.11,3.78-5.25l10.44-34.32c.48-1.53-.21-3.19-1.64-3.93l-13.72-7.09c-1.95-1.01-4.31.12-4.76,2.27l-.98,4.74-25.84-8.5v-3.88c0-2.5-1.95-4.56-4.44-4.7l-7.46-.43-7.46.43c-2.49.14-4.44,2.2-4.44,4.7v3.88l-25.84,8.5-.98-4.74c-.44-2.14-2.81-3.27-4.76-2.27l-13.72,7.09c-1.43.74-2.12,2.4-1.64,3.93l10.44,34.33Z" />
          <rect x="40.28" y="179.05" width="119.45" height="8.16" rx=".99" ry=".99" />
          <path d="M43.8,121.56c.98,5.34,3.47,10.31,7.2,14.35l1.83,1.99v28.66c0,.34-.21.65-.53.78l-11.5,4.62c-.86.35-.61,1.63.31,1.63h117.43c.93,0,1.18-1.28.31-1.63l-11.5-4.62c-.32-.13-.53-.44-.53-.78v-28.11l2.34-2.54c3.73-4.04,6.22-9.01,7.2-14.35l1.85-10.05c.2-1.09-.34-2.19-1.32-2.7l-3.25-1.68c-1.49-.77-3.31.1-3.64,1.75l-.73,3.66c-.29,1.47-1.78,2.36-3.21,1.92l-7.4-2.26c-1.25-.38-2-1.65-1.74-2.93l1.09-5.28c.3-1.44-.69-2.83-2.15-3.02l-21.98-2.85c-1.51-.2-2.85.98-2.85,2.51v5.37c0,1.44-1.2,2.59-2.63,2.52l-8.22-.35h-.22s-8.22.35-8.22.35c-1.44.06-2.63-1.09-2.63-2.52v-5.37c0-1.52-1.34-2.7-2.85-2.51l-21.98,2.85c-1.46.19-2.45,1.58-2.15,3.02l1.09,5.28c.26,1.28-.49,2.55-1.74,2.93l-7.4,2.26c-1.43.44-2.92-.46-3.21-1.92l-.73-3.66c-.33-1.65-2.14-2.52-3.64-1.75l-3.25,1.68c-.99.51-1.52,1.61-1.32,2.7l1.85,10.05ZM126.95,133.91c0-1.33,1.17-2.36,2.5-2.18l7.21.97c1.09.15,1.91,1.08,1.91,2.18v12.42c0,1.07-.76,1.98-1.81,2.17l-7.21,1.31c-1.35.24-2.6-.79-2.6-2.17v-14.7ZM88.19,139.87c0-5.72,4.64-10.37,10.37-10.37h2.9c5.72,0,10.37,4.64,10.37,10.37v24.59c0,1.05-.85,1.9-1.9,1.9h-19.83c-1.05,0-1.9-.85-1.9-1.9v-24.59ZM61.11,134.88c0-1.1.82-2.04,1.91-2.18l7.21-.97c1.32-.18,2.5.85,2.5,2.18v14.7c0,1.37-1.24,2.41-2.6,2.17l-7.21-1.31c-1.05-.19-1.81-1.1-1.81-2.17v-12.42Z" />
        </svg>
      ),
    },
    {
      name: 'Degen Spin',
      href: 'https://app.degencoinflip.com/spin',
      notification: false,
      svgSrc: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 200 200"
          className="transition-all duration-300"
          fill={pathname === '/spin' || pathname === '/spin/' ? '#e3e3e3' : '#84898c'}
        >
          <path d="M151.62,31.21c-9.74-8.72-22.32-10.75-22.32-10.75-12.38,4.26-13.39,21.71-13.39,21.71-36.12-5.68-68.99,20.7-68.99,20.7-10.75-11.16-21.1-10.62-21.1-10.62-8.52,3.58-16.23,29.29-16.23,29.29-12.17,54.18,24.35,77.11,24.35,77.11,26.58,21.1,65.03,11.97,65.03,11.97l5.58-1.62.71,5.58c-2.54,11.06-7.2,18.97-7.2,18.97,46.67-.81,71.83-55.6,71.83-55.6,26.38-65.74-8.52-98-18.26-106.73ZM84.62,113.67c-.26.99-2.09,2.24-3.11,2.22-11.58-.3-23.46-1.63-34.55,1.73-.37.11-.76.23-1.13.13-.64-.18-.41-2.04-.27-2.69.14-.65.6-1.17,1.05-1.65.67-.7,1.37-1.37,2.1-1.98,10.13-8.66,24.57-8.58,34.82.16.63.54,1.3,1.28,1.09,2.08ZM116.15,121.17c-.57,1.57-1.29,4.54-2.89,5.39-1.81.95-5.6.53-7.53.15-.59-.12-1.19-.29-1.63-.69-.67-.6-.84-1.63-.61-2.5.1-.39.27-.75.47-1.09.26-.43.58-.83.91-1.21,2.17-2.46,5.06-4.27,8.22-5.14,1.98-.55,3.61.07,3.67,2.37.02.93-.27,1.84-.59,2.72ZM143.83,73.59c-7.92,8.47-15.1,17.63-21.41,27.36-.41.63-1.79.26-2.45-.09-.4-.21-.53-.71-.61-1.15-1.28-7.28.78-15.08,5.49-20.78,2.75-3.32,6.37-5.9,10.37-7.48.37-.15,1.05-.37,1.86-.61,3.52-1.02,10.41-1.16,6.75,2.75Z" />
        </svg>
      ),
    },
    {
      name: 'Degen Coin Dozer',
      href: 'https://app.degencoinflip.com/dozer',
      notification: false,
      svgSrc: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 200 200"
          className="transition-all duration-300"
          fill={pathname === '/dozer' || pathname === '/dozer/' ? '#e3e3e3' : '#84898c'}
        >
          <path d="M146.45,69.41c-1.03-.54-2.18-.95-2.92-1.84-1.78-2.16-.09-5.33,1.43-7.69,6.25-9.67,16.62-33.29,7.8-44.07-8.48-10.36-24.91,6.76-34.66,8.71-7.23,1.45-14.66-1.19-22.02-.79-4.27.23-8.48,1.48-12.75,1.28-11.69-.56-20.83-11.69-32.52-12.31-1.44-.08-2.99.04-4.14.92-1.4,1.07-1.84,2.97-2.11,4.72-2.27,14.76.95,30.31,8.91,42.95,1.21,1.93,2.54,4.46,1.19,6.29-.71.96-1.94,1.35-3.02,1.86-7.86,3.68-8.53,15.72-2.88,22.31,5.65,6.58,15.11,8.52,23.78,8.18,8.67-.35,17.21-2.56,25.89-2.56,8.76,0,17.37,2.24,26.11,2.65,8.75.41,18.29-1.41,24.13-7.93,3.2-3.57,4.56-8.81,3.86-13.49-.58-3.87-2.56-7.35-6.08-9.17ZM86.08,79.39c-.07.03-.14.04-.21.04-.35.01-.71-.25-.98-.51-4.98-4.55-10.39-9.31-17.06-10.23-.96-.13-2.02-.22-2.72-.89-2.67-2.54,3.9-3.02,4.99-3.07,3.2-.15,6.46.42,9.3,1.94,4.22,2.26,7.34,6.8,7.21,11.58-.01.44-.11.97-.52,1.14ZM99,85.8c-2.13,0-3.86-.86-3.86-1.93s1.73-1.93,3.86-1.93,3.86.86,3.86,1.93-1.73,1.93-3.86,1.93ZM130.59,67.81c-.7.67-1.76.75-2.72.89-6.68.92-12.09,5.69-17.06,10.23-.28.25-.63.52-.98.51-.07,0-.14-.02-.21-.04-.41-.17-.51-.69-.52-1.14-.13-4.79,2.98-9.32,7.21-11.58,2.84-1.52,6.1-2.09,9.3-1.94,1.09.05,7.66.53,4.99,3.07Z" />
          <g>
            <path d="M100,103.93c-24.19,0-43.8,18.7-43.8,41.78s19.61,41.78,43.8,41.78,43.8-18.7,43.8-41.78-19.61-41.78-43.8-41.78ZM100,183.63c-21.96,0-39.76-16.98-39.76-37.92s17.8-37.92,39.76-37.92,39.76,16.98,39.76,37.92-17.8,37.92-39.76,37.92Z" />
            <ellipse cx="100" cy="146.11" rx="32.19" ry="30.7" />
          </g>
          <g>
            <g>
              <path d="M162.88,88.56c-.93,2.55-2.36,4.92-4.28,6.79-4.64,4.53-10.9,6.69-17.44,7.36,1.69.47,3.23,1.04,4.7,1.68,5.5-3.17,11.39-2.9,13.47.63,1.39,2.37.6,5.51-1.69,8.31.37.44.73.91,1.08,1.38,3.47-.55,6.49.34,7.85,2.67,1.34,2.28.69,5.29-1.4,8.01.3.6.6,1.19.9,1.81,1.13-.3,2.26-.51,3.33-.51h.05c2.72.01,4.81,1.02,5.88,2.85,1.68,2.87.22,6.86-3.28,10,6.06,10.01,6.78-5.36,6.78-5.36,7.65-28.92-13.25-43.82-15.94-45.59Z" />
              <g>
                <ellipse
                  cx="148.66"
                  cy="111.47"
                  rx="9.09"
                  ry="5.38"
                  transform="translate(-35.96 90.47) rotate(-30.37)"
                />
                <ellipse
                  cx="156.11"
                  cy="123.74"
                  rx="9.09"
                  ry="5.38"
                  transform="translate(-41.14 95.92) rotate(-30.37)"
                />
                <ellipse
                  cx="164.66"
                  cy="136.22"
                  rx="9.09"
                  ry="5.38"
                  transform="translate(-46.28 101.96) rotate(-30.37)"
                />
              </g>
            </g>
            <g>
              <path d="M37.12,88.56c.93,2.55,2.36,4.92,4.28,6.79,4.64,4.53,10.9,6.69,17.44,7.36-1.69.47-3.23,1.04-4.7,1.68-5.5-3.17-11.39-2.9-13.47.63-1.39,2.37-.6,5.51,1.69,8.31-.37.44-.73.91-1.08,1.38-3.47-.55-6.49.34-7.85,2.67-1.34,2.28-.69,5.29,1.4,8.01-.3.6-.6,1.19-.9,1.81-1.13-.3-2.26-.51-3.33-.51h-.05c-2.72.01-4.81,1.02-5.88,2.85-1.68,2.87-.22,6.86,3.28,10-6.06,10.01-6.78-5.36-6.78-5.36-7.65-28.92,13.25-43.82,15.94-45.59Z" />
              <g>
                <ellipse
                  cx="51.34"
                  cy="111.47"
                  rx="5.38"
                  ry="9.09"
                  transform="translate(-70.79 99.4) rotate(-59.63)"
                />
                <ellipse
                  cx="43.89"
                  cy="123.74"
                  rx="5.38"
                  ry="9.09"
                  transform="translate(-85.06 99.03) rotate(-59.63)"
                />
                <ellipse
                  cx="35.34"
                  cy="136.22"
                  rx="5.38"
                  ry="9.09"
                  transform="translate(-100.05 97.83) rotate(-59.63)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
    },
  ];

  const socials = [
    {
      name: 'Twitter',
      href: 'https://x.com/degencoinflip',
      svgSrc: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 200 200"
        >
          <rect
            fill="#212632"
            x="23.14"
            y="23.14"
            width="153.71"
            height="153.71"
            rx="76.86"
            ry="76.86"
          />
          <path
            fill="#84898c"
            d="M144.72,140.9c-2.5-3.33-5.04-6.71-7.54-10.05h0c-9.24-12.32-18.49-24.64-27.72-36.96,6.6-7.03,13.2-14.06,19.8-21.09,4.27-4.55,8.54-9.1,12.81-13.66l.93-.99h-9.93l-.17.19c-4.95,5.28-9.9,10.55-14.85,15.83-4.33,4.62-8.66,9.23-12.99,13.85-7.41-9.87-14.82-19.75-22.22-29.63l-.18-.23h-26.8l.69.93c11.08,15.07,22.18,30.13,33.27,45.19-6.62,7.06-13.25,14.12-19.87,21.18l-15.37,16.38h9.89l13.44-14.32c5.42-5.78,10.84-11.55,16.27-17.33,3.87,5.25,7.73,10.49,11.59,15.74,3.85,5.22,7.69,10.45,11.54,15.67l.18.24h27.96l-.71-.94ZM98.36,104.01h0s-3.23-4.38-3.23-4.38l-25.35-34.44h9.36c5.82,7.76,12.74,16.99,18.78,25.03l2.25,3h0s.3.39.3.39c1.23,1.64,2.46,3.28,3.69,4.92l.42.56h0c6.86,9.15,13.73,18.31,20.59,27.46l6.19,8.25h-10.32l-21.96-29.83h0s-.32-.43-.32-.43l-.39-.53Z"
          />
        </svg>
      ),
    },
    {
      name: 'Discord',
      href: 'https://discord.gg/degencoinflip',
      svgSrc: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 200 200"
        >
          <rect
            fill="#212632"
            x="23.14"
            y="23.14"
            width="153.71"
            height="153.71"
            rx="76.86"
            ry="76.86"
          />
          <path
            fill="#84898c"
            d="M131.09,72.23s-7.47-5-19.28-5.74c0,0-1.64,4.68-1.64,4.68,0-.03-5.25-.82-5.59-.85-2.98-.29-6.15-.26-9.13-.03-.35.03-5.62.87-5.62.88l-1.64-4.68c-11.81.74-19.28,5.74-19.28,5.74-17.64,27.24-12.88,49.64-12.88,49.64,5.91,6.24,22.89,11.65,22.89,11.65l4.51-7.88-7.22-3.28s1.07-2.13,1.07-2.13c6.2,3.1,13.31,4.8,20.24,5.18,6.19.33,12.52-.62,18.42-2.47,1.16-.36,2.31-.77,3.44-1.22.32-.13,3.25-1.58,3.34-1.49l1.07,2.13-7.22,3.28,4.51,7.88s16.98-5.41,22.89-11.65c0,0,4.76-22.4-12.88-49.64ZM85.32,111.77c-4.43,0-8.02-3.91-8.02-8.74s3.59-8.74,8.02-8.74,8.02,3.91,8.02,8.74-3.59,8.74-8.02,8.74ZM114.68,111.77c-4.43,0-8.02-3.91-8.02-8.74s3.59-8.74,8.02-8.74,8.02,3.91,8.02,8.74-3.59,8.74-8.02,8.74Z"
          />
        </svg>
      ),
    },
    {
      name: 'Coinbase',
      href: 'https://www.coinbase.com/web3/dapps/degen-coin-flip',
      svgSrc: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 200 200"
        >
          <rect
            fill="#212632"
            x="23.14"
            y="23.14"
            width="153.71"
            height="153.71"
            rx="76.86"
            ry="76.86"
          />
          <path
            fill="#84898c"
            d="M100.1,123.87c-13.96,0-25.1-12.09-23.51-26.37,1.2-10.77,9.81-19.48,20.57-20.77,12.36-1.49,23.08,6.56,25.87,17.75h23.85c-2.8-23.98-23.6-42.46-48.53-41.56-24.44.89-44.37,20.76-45.33,45.2-1.05,26.88,20.43,49,47.08,49,24.62,0,44.82-18.89,46.92-42.96h-23.62c-1.88,11.19-11.59,19.72-23.31,19.72Z"
          />
        </svg>
      ),
    },
  ];

  return (
    <div
      className={`z-[60] lg:z-10 fixed top-0 left-0 min-w-[0px] bg-black/60 backdrop-blur-sm ${isExpanded
        ? 'block w-full lg:min-w-[250px] lg:w-[250px]'
        : 'hidden lg:block w-[0px] lg:min-w-[80px] lg:w-[80px]'
        } transition-all min-h-[100vh]`}
    >
      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 min-h-[100vh] ${isExpanded ? 'flex w-[250px]' : 'hidden lg:flex w-[0px] lg:w-[80px]'
          } transition-[width] bg-[#323c49] flex-col items-center justify-between gap-6 p-4 lg:p-6 overflow-hidden`}
      >
        <div className="flex flex-col items-center w-full gap-12 lg:gap-16">
          <div
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-[32px] min-w-[32px] cursor-pointer self-start hover:brightness-125"
          >
            <svg
              className="w-full h-full transition-all"
              xmlns="http://www.w3.org/2000/svg"
              id="Layer_1"
              viewBox="0 0 200 200"
            >
              <rect
                fill="#606060"
                x="35.17"
                y="32.16"
                width="129.67"
                height="25.44"
                rx="12.72"
                ry="12.72"
              />
              <rect
                fill="#606060"
                x="35.17"
                y="87.28"
                width="129.67"
                height="25.44"
                rx="12.72"
                ry="12.72"
              />
              <rect
                fill="#606060"
                x="35.17"
                y="142.4"
                width="129.67"
                height="25.44"
                rx="12.72"
                ry="12.72"
              />
            </svg>
          </div>
          <div className="flex flex-col items-center w-full gap-4 lg:gap-6">
            <NavLink
              onClick={() => closeSidebar()}
              to="https://app.degencoinflip.com"
              className="self-start flex items-center select-none w-full cursor-pointer group"
            >
              <div className="w-[32px] min-w-[32px] group-hover:brightness-125">
                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 495.398 495.398"
                  className="transition-all duration-300"
                  fill={'#84898c'}
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <g>
                      <g>
                        <g>
                          <path d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391 v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158 c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747 c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"></path>{' '}
                          <path d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401 c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79 c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div
                className={`min-w-max ml-2 ${isExpanded ? 'opacity-100 block' : 'opacity-0 hidden'
                  } transition-all`}
              >
                <p className={`uppercase ${pathname === 'app.degencoinflip.com' ? 'text-[#e3e3e3]' : 'text-[#85888c]'} text-[14px] font-bagorNormal leading-none tracking-wider group-hover:brightness-125 m-0`}>
                  Home
                </p>
              </div>
            </NavLink>
            {pages.map((page, index) => (
              <NavLink
                onClick={() => closeSidebar()}
                to={page.href}
                key={index}
                className="self-start flex items-center select-none w-full cursor-pointer group"
              >
                <div className="relative w-[32px] min-w-[32px] group-hover:brightness-125">
                  {page.svgSrc}
                  {page.notification && (<div className='absolute -top-1 -right-1 w-2 h-2 rounded-full bg-red-500 animate-pulse'></div>)}
                </div>
                <div
                  className={`min-w-max ml-2 ${isExpanded ? 'opacity-100 block' : 'opacity-0 hidden'
                    } transition-all`}
                >
                  <p className={`uppercase ${pathname === page.href || pathname === page.href + '/' ? 'text-[#e3e3e3]' : 'text-[#85888c]'} text-[14px] font-bagorNormal leading-none tracking-wider group-hover:brightness-125 m-0`}>
                    {page.name}
                  </p>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
        <div className="flex flex-col items-center w-full gap-2 lg:gap-4">
          {socials.map((social, index) => (
            <a
              href={social.href}
              target="_blank"
              rel="noreferrer"
              key={index}
              className="w-[32px] min-w-[32px] cursor-pointer self-start select-none hover:brightness-125"
            >
              {social.svgSrc}
            </a>
          ))}
          <div className="w-[24px] min-w-[24px] cursor-pointer self-start select-none hover:brightness-125">
            <div
              id="anj-39a70568-0b26-48ee-a12e-50a8315983f7"
              data-anj-seal-id="39a70568-0b26-48ee-a12e-50a8315983f7"
              data-anj-image-size="1"
              data-anj-image-type="basic-small"
              className="anj-seal w-full h-full transition-all"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { Sidebar };
